(function(){
  'use strict';
  var _pzFilterDone = false;
  function _pzFilterBoot(){
    if(_pzFilterDone) return true;
    if(typeof pzSearchData==='undefined'||!pzSearchData||!pzSearchData.length){
      return false;
    }
    _pzFilterDone = true;
    _pzFilterMain();
    return true;
  }
  if(!_pzFilterBoot()){
    window._pzSearchDataCallbacks=window._pzSearchDataCallbacks||[];
    window._pzSearchDataCallbacks.push(function(){ if(!_pzFilterDone){ _pzFilterDone=true; _pzFilterMain(); } });
    var _poll=setInterval(function(){if(_pzFilterBoot())clearInterval(_poll);},200);
    return;
  }
  function _pzFilterMain(){

  /* DOM上のカードのhrefを収集し、現在のコレクションの商品だけに絞る */
  var allItems = pzSearchData;
  var items, TOTAL;
  var originalOrder = [];
  var isAllItems = window.location.pathname.indexOf('/all-items') >= 0 || window.location.pathname === '/collections/all';
  var hideCat = !isAllItems;
  var hideSize = false;

  /*
    検索語つきの一覧（/collections/all-items?kw=検索語）。
    合う・合わないはヘッダーの候補と同じ判定（sections/header.liquid の window.pzSearchFind）。
    サーバーが出したカードのうち合わないものを取り除き、合うのにカードが無い商品（all-items に入っていない商品、
    250 件を超えた分）は検索データからカードを作って足す。そのあとのフィルター・並び替えは、残ったカードにそのまま効く。
  */
  var KW = '';
  try { KW = isAllItems ? (new URLSearchParams(window.location.search).get('kw') || '').trim() : ''; } catch(e){}
  if(KW && typeof window.pzSearchFind !== 'function') KW = '';

  function _kwCard(tpl, it){
    var li = tpl.cloneNode(true);
    var imgs = li.querySelectorAll('img');
    for(var i=0;i<imgs.length;i++){
      if(i>0 || !it.i){ imgs[i].parentNode.removeChild(imgs[i]); continue; }
      imgs[i].removeAttribute('srcset'); imgs[i].removeAttribute('sizes');
      imgs[i].removeAttribute('width'); imgs[i].removeAttribute('height');
      imgs[i].src = it.i.replace(/([?&])width=\d+/, '$1width=533');
      imgs[i].alt = it.t;
    }
    li.querySelectorAll('[id]').forEach(function(el){ el.removeAttribute('id'); });
    li.querySelectorAll('a[href^="/products/"]').forEach(function(a){
      a.setAttribute('href', encodeURI(it.h));
      a.removeAttribute('aria-labelledby');
      a.textContent = it.t;
    });
    var v = li.querySelector('.card-information .caption-with-letter-spacing'); if(v) v.textContent = it.v || '';
    li.querySelectorAll('.price-item').forEach(function(p){ p.textContent = p.tagName === 'S' ? '' : (it.p || ''); });
    li.querySelectorAll('.card__badge').forEach(function(b){ b.innerHTML = ''; });
    var chips = li.querySelector('.pz-size-chips');
    if(chips){
      chips.innerHTML = '';
      (it.sz || []).forEach(function(s){ var sp = document.createElement('span'); sp.className = 'pz-size-chip'; sp.textContent = s; chips.appendChild(sp); });
    }
    return li;
  }

  function _kwDone(count){
    var c = document.getElementById('pzKwCount'); if(c) c.textContent = count + '件';
    var root = document.documentElement;
    if(count === 0){
      root.classList.add('pz-kw-none');
      var box = document.getElementById('ProductGridContainer');
      if(box){
        var d = document.createElement('div'); d.className = 'pz-kw-empty';
        d.appendChild(document.createTextNode('「' + KW + '」に一致する商品がありません'));
        d.appendChild(document.createElement('br'));
        var a = document.createElement('a'); a.href = window.location.pathname; a.textContent = 'すべての商品を見る'; d.appendChild(a);
        box.innerHTML = ''; box.appendChild(d);
      }
    }
    root.classList.add('pz-kw-ready');
  }

  function _kwBuild(grid){
    var found = window.pzSearchFind(KW);
    var matches = found ? found.matches : [];
    var byHref = {};
    matches.forEach(function(it){ byHref[it.h] = it; });
    var tpl = null, have = {};
    Array.prototype.slice.call(grid.children).forEach(function(li){
      if(!li.classList.contains('grid__item')){ grid.removeChild(li); return; } /* 「もっと見る」の行 */
      var a = li.querySelector('a[href^="/products/"]');
      var h = a ? decodeURIComponent(a.getAttribute('href').split('?')[0]) : '';
      if(!tpl && a) tpl = li.cloneNode(true);
      if(!byHref[h] || have[h]){ grid.removeChild(li); return; }
      have[h] = true;
    });
    if(tpl){
      matches.forEach(function(it){ if(!have[it.h]){ grid.appendChild(_kwCard(tpl, it)); have[it.h] = true; } });
    }
    grid.querySelectorAll('.grid__item').forEach(function(li){
      li.removeAttribute('data-pz-group');
      li.classList.remove('scroll-trigger','animate--slide-in','scroll-trigger--offscreen','scroll-trigger--cancel');
      li.style.display = '';
    });
    return matches.filter(function(it){ return have[it.h]; });
  }

  function _buildItems(){
    var grid = document.getElementById('product-grid');
    if(KW){
      items = grid ? _kwBuild(grid) : [];
      TOTAL = items.length;
      _kwDone(TOTAL);
    } else if(grid){
      var hrefs = [];
      grid.querySelectorAll('.grid__item a[href^="/products/"]').forEach(function(a){
        var h = decodeURIComponent(a.getAttribute('href').split('?')[0]);
        if(hrefs.indexOf(h)<0) hrefs.push(h);
      });
      if(hrefs.length > 0){
        items = allItems.filter(function(it){ return hrefs.indexOf(it.h)>=0; });
      } else {
        items = allItems;
      }
    } else {
      items = allItems;
    }
    TOTAL = items.length;
    /* 帽子・バッグ・グッズのみのコレクションならサイズ非表示 */
    var noSizeTypes = ['キャップ・ハット','バッグ','グッズ','ペット'];
    var hasClothing = items.some(function(it){ return it.tp && noSizeTypes.indexOf(it.tp) < 0; });
    hideSize = !hasClothing;
  }

  /* ── slugマッピング ── */
  var slugMap = {
    cat: {'tshirts':'Tシャツ','sweat':'スウェット','hoody':'フードスウェット','longt':'ロングTシャツ','tanktop':'タンクトップ','outer':'アウター','pants':'パンツ','shorts':'ショートパンツ','polo':'ドライ・ポロシャツ','cap':'キャップ・ハット','bag':'バッグ','goods':'グッズ','pet':'ペット','shirts':'シャツ'},
    sz: {'XS':'XS','S':'S','M':'M','L':'L','XL':'XL','2XL':'2XL','3XL':'3XL','4XL':'4XL','5XL':'5XL','6XL':'6XL','kids':'キッズ'},
    pr: {'screen':'スクリーンプリント','fullcolor':'フルカラープリント','embroidery':'刺繍'},
    mt: {'cotton':'綿100%','polyester':'ポリエステル100%','blend':'混紡','nylon':'ナイロン・撥水','eva':'EVA樹脂'},
    mk: {}
  };
  var reverseMap = {};
  Object.keys(slugMap).forEach(function(g){ reverseMap[g]={}; Object.keys(slugMap[g]).forEach(function(s){ reverseMap[g][slugMap[g][s]]=s; }); });
  function toSlug(g,v){ return (reverseMap[g]&&reverseMap[g][v])||v; }
  function fromSlug(g,s){ return (slugMap[g]&&slugMap[g][s])||s; }
  function toSlugs(g,a){ return a.map(function(v){return toSlug(g,v);}); }
  function fromSlugs(g,a){ return a.map(function(v){return fromSlug(g,v);}); }

  /* ── サイズ統合マッピング ── */
  /* 内部値(タグ)→表示名、複数タグを1つの表示名に統合 */
  var sizeAliases = {
    'XS': ['XS','SS','YL','160'], 'S': ['S'], 'M': ['M'], 'L': ['L'],
    'XL': ['XL','LL'], '2XL': ['2XL','3L'], '3XL': ['3XL','4L'],
    '4XL': ['4XL','5L'], '5XL': ['5XL','6L'], '6XL': ['7L'],
    'キッズ': ['キッズ']
  };
  var sizeDisplayOrder = ['XS','S','M','L','XL','2XL','3XL','4XL','5XL','6XL','キッズ'];
  var sizeDisplayLabels = {
    'XS':'XS(SS/YL/160)','S':'S','M':'M','L':'L','XL':'XL(LL)',
    '2XL':'2XL(3L)','3XL':'3XL(4L)','4XL':'4XL(5L)','5XL':'5XL(6L)',
    '6XL':'6XL(7L)','キッズ':'キッズ'
  };
  /* 内部タグ→統合キー */
  var tagToSizeKey = {};
  Object.keys(sizeAliases).forEach(function(key){
    sizeAliases[key].forEach(function(tag){ tagToSizeKey[tag] = key; });
  });

  /* ── データ集計（init内で_buildItems後に呼ぶ） ── */
  var filters, prices, minP, maxP;
  function _buildFilters(){
    filters = {
      cat:{label:"カテゴリ",map:{},key:"cat"},
      sz:{label:"サイズ",map:{},key:"sz"},
      pr:{label:"加工方法",map:{},key:"pr"},
      mt:{label:"素材",map:{},key:"mt"},
      mk:{label:"メーカー",map:{},key:"mk"}
    };
    prices = [];
    items.forEach(function(it){
    if(it.pn>0) prices.push(it.pn);
    if(it.tp) filters.cat.map[it.tp]=(filters.cat.map[it.tp]||0)+1;
    (it.sz||[]).forEach(function(v){
      var k = tagToSizeKey[v];
      if(k) filters.sz.map[k]=(filters.sz.map[k]||0)+1;
    });
    (it.pr||[]).forEach(function(v){ filters.pr.map[v]=(filters.pr.map[v]||0)+1; });
    (it.mt||[]).forEach(function(v){ filters.mt.map[v]=(filters.mt.map[v]||0)+1; });
    if(it.v) filters.mk.map[it.v]=(filters.mk.map[it.v]||0)+1;
  });
    minP = prices.length ? Math.min.apply(null,prices) : 0;
    maxP = prices.length ? Math.max.apply(null,prices) : 10000;
  }

  /* ── URL ── */
  function stateToURL(st){
    var p=new URLSearchParams();
    if(KW) p.set('kw',KW); /* フィルター・並び替えを変えても検索語を残す */
    ['cat','sz','pr','mt','mk'].forEach(function(k){ if(st[k].length) p.set(k,toSlugs(k,st[k]).join(',')); });
    if(st.pMin>minP) p.set('pmin',st.pMin);
    if(st.pMax<maxP) p.set('pmax',st.pMax);
    if(st.sort&&st.sort!=='default') p.set('sort',st.sort);
    return p.toString();
  }
  function stateFromURL(){
    var p=new URLSearchParams(window.location.search);
    var isNewArrival = window.location.pathname.indexOf('/collections/new-arrival') >= 0;
    var st={cat:[],sz:[],pr:[],mt:[],mk:[],pMin:minP,pMax:maxP,sort:isNewArrival?'updated':'default'};
    ['cat','sz','pr','mt','mk'].forEach(function(k){ var v=p.get(k); if(v) st[k]=fromSlugs(k,v.split(',').filter(Boolean)); });
    var pm=p.get('pmin'); if(pm) st.pMin=parseInt(pm);
    var px=p.get('pmax'); if(px) st.pMax=parseInt(px);
    var s=p.get('sort'); if(s) st.sort=s;
    return st;
  }
  function pushURL(st){ var qs=stateToURL(st); history.replaceState(null,'',window.location.pathname+(qs?'?'+qs:'')); }
  function hasActive(st){ return st.cat.length||st.sz.length||st.pr.length||st.mt.length||st.mk.length||st.pMin>minP||st.pMax<maxP; }

  var state;
  var currentSub = null;

  function sortedKeys(obj){ return Object.keys(obj).sort(function(a,b){return obj[b]-obj[a];}); }
  function esc(s){ var d=document.createElement('div'); d.textContent=s; return d.innerHTML; }
  var filterLabels = {cat:'カテゴリ',sz:'サイズ',pr:'加工方法',mt:'素材',mk:'メーカー'};

  /* ── 選択済みチップHTML ── */
  function renderChips(){
    var html='';
    var showKeys = ['cat','sz','pr','mt','mk'].filter(function(key){
      if(key==='cat' && hideCat) return false;
      if(key==='sz' && hideSize) return false;
      return true;
    });
    showKeys.forEach(function(key){
      state[key].forEach(function(v){
        var label = (key==='sz' && sizeDisplayLabels[v]) ? sizeDisplayLabels[v] : v;
        html+='<span class="pzc-active-chip" data-key="'+key+'" data-val="'+esc(v)+'">'
          +esc(label)
          +'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="margin-left:4px;cursor:pointer"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/><\/svg>'
          +'<\/span>';
      });
    });
    return html;
  }

  /* ── メイン画面 ── */
  function renderMain(){
    var body=document.getElementById('pzFilterBody'); if(!body) return;
    var html='';

    /* 選択済みチップ */
    var chips = renderChips();
    if(chips){
      html+='<div class="pzc-active-chips" style="display:flex;flex-wrap:wrap;gap:8px;padding-bottom:12px;margin-bottom:12px;border-bottom:1px solid #f0f0f0">'+chips+'<\/div>';
    }

    /* フィルターグループ行 */
    var showKeys = ['cat','sz','pr','mt','mk'].filter(function(key){
      if(key==='cat' && hideCat) return false;
      if(key==='sz' && hideSize) return false;
      return true;
    });
    showKeys.forEach(function(key){
      var f=filters[key], cnt=state[key].length;
      html+='<div class="pzc-filter-row" data-sub="'+key+'"><span class="pzc-filter-row__label">'+esc(f.label)
        +(cnt>0?'<span style="color:var(--pzc-red);font-size:12px;margin-left:4px">('+cnt+')<\/span>':'')
        +'<\/span><svg width="16" height="16" fill="none" stroke="#999" stroke-width="2" viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"/><\/svg><\/div>';
    });

    /* 価格帯（2つのトグル） */
    html+='<div class="pzc-filter__group" style="margin-top:16px;padding-top:16px;border-top:1px solid var(--pzc-border)">'
      +'<div class="pzc-filter__label">価格帯<\/div>'
      +'<div style="position:relative;height:32px;margin:8px 0">'
      +'<div id="pzPriceTrack" style="position:absolute;top:14px;left:0;right:0;height:4px;background:#ddd;border-radius:2px"><div id="pzPriceRange" style="position:absolute;height:100%;background:var(--pzc-red,#FF3C00);border-radius:2px"><\/div><\/div>'
      +'<input type="range" id="pzPriceMin" min="'+minP+'" max="'+maxP+'" value="'+state.pMin+'" step="100" style="position:absolute;top:4px;left:0;width:100%;-webkit-appearance:none;appearance:none;background:transparent;pointer-events:none;z-index:2">'
      +'<input type="range" id="pzPriceMax" min="'+minP+'" max="'+maxP+'" value="'+state.pMax+'" step="100" style="position:absolute;top:4px;left:0;width:100%;-webkit-appearance:none;appearance:none;background:transparent;pointer-events:none;z-index:3">'
      +'<\/div>'
      +'<div class="pzc-filter__range-labels"><span id="pzPriceMinLabel">¥'+state.pMin.toLocaleString()+'<\/span><span id="pzPriceMaxLabel">¥'+state.pMax.toLocaleString()+'<\/span><\/div>'
      +'<\/div>';

    /* レビュー */
    html+='<div class="pzc-filter__group" style="margin-top:16px;padding-top:16px;border-top:1px solid var(--pzc-border)"><div class="pzc-filter__label">レビュー<\/div>';
    [5,4].forEach(function(s){ var st=''; for(var i=1;i<=5;i++) st+='<span style="color:'+(i<=s?'#f5a623':'#ddd')+'">★<\/span>'; html+='<div style="padding:4px 0;opacity:0.4">'+st+' '+s+'つ星以上<\/div>'; });
    html+='<p style="font-size:11px;color:#999;margin:6px 0 0">※ レビュー機能は準備中です<\/p><\/div>';

    body.innerHTML=html;

    /* チップ削除イベント */
    body.querySelectorAll('.pzc-active-chip').forEach(function(chip){
      chip.addEventListener('click',function(){
        var k=this.getAttribute('data-key'), v=this.getAttribute('data-val');
        state[k]=state[k].filter(function(x){return x!==v;});
        renderMain();
      });
    });

    /* フィルター行イベント */
    body.querySelectorAll('.pzc-filter-row').forEach(function(r){
      r.addEventListener('click',function(){ currentSub=this.getAttribute('data-sub'); renderSub(currentSub); });
    });

    /* 価格スライダーイベント */
    var slMin=document.getElementById('pzPriceMin'), slMax=document.getElementById('pzPriceMax');
    var rangeBar=document.getElementById('pzPriceRange');
    function updateRange(){
      var lo=parseInt(slMin.value), hi=parseInt(slMax.value);
      if(lo>hi){ var t=lo; lo=hi; hi=t; }
      state.pMin=lo; state.pMax=hi;
      document.getElementById('pzPriceMinLabel').textContent='¥'+lo.toLocaleString();
      document.getElementById('pzPriceMaxLabel').textContent='¥'+hi.toLocaleString();
      var pct1=((lo-minP)/(maxP-minP))*100, pct2=((hi-minP)/(maxP-minP))*100;
      rangeBar.style.left=pct1+'%'; rangeBar.style.width=(pct2-pct1)+'%';
    }
    if(slMin&&slMax){
      slMin.addEventListener('input',updateRange);
      slMax.addEventListener('input',updateRange);
      updateRange();
    }
  }

  /* ── サブメニュー ── */
  function renderSub(key){
    var f=filters[key], body=document.getElementById('pzFilterBody'), header=document.getElementById('pzFilterHeaderInner');
    header.innerHTML='<button class="pzc-filter__back" id="pzFilterBack" style="background:none;border:none;cursor:pointer;display:flex;align-items:center;gap:6px;font-size:16px;font-weight:800;color:var(--pzc-black);padding:0"><svg width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"/><\/svg>'+esc(f.label)+'<\/button>';
    document.getElementById('pzFilterBack').addEventListener('click',function(){ currentSub=null; renderMainHeader(); renderMain(); });
    /* サブメニューではフッター非表示 */
    var ft=document.querySelector('.pzc-filter__footer'); if(ft) ft.style.display='none';

    var html='<div style="margin-bottom:8px"><a href="javascript:void(0)" id="pzSubClear" style="font-size:13px;color:var(--pzc-red);text-decoration:none">'+esc(f.label)+'をクリア<\/a><\/div>';

    /* サイズは特殊順 */
    var keys;
    if(key==='sz'){
      keys = sizeDisplayOrder.filter(function(k){ return filters.sz.map[k]; });
    } else {
      keys = sortedKeys(f.map);
    }

    keys.forEach(function(v){
      var checked=state[key].indexOf(v)>=0;
      var displayLabel = (key==='sz' && sizeDisplayLabels[v]) ? sizeDisplayLabels[v] : v;
      html+='<label style="display:flex;align-items:center;justify-content:space-between;padding:12px 0;border-bottom:1px solid #f0f0f0;cursor:pointer"><span style="display:flex;align-items:center;gap:10px">'
        +'<input type="checkbox" data-key="'+key+'" value="'+esc(v)+'"'+(checked?' checked':'')+' style="width:18px;height:18px;accent-color:var(--pzc-red)"><span style="font-size:14px">'+esc(displayLabel)+'<\/span><\/span>'
        +'<span style="font-size:13px;color:#999">'+f.map[v]+'<\/span><\/label>';
    });
    body.innerHTML=html;
    body.querySelectorAll('input[type=checkbox]').forEach(function(cb){
      cb.addEventListener('change',function(){ var k=this.getAttribute('data-key'),v=this.value; if(this.checked){if(state[k].indexOf(v)<0)state[k].push(v);}else{state[k]=state[k].filter(function(x){return x!==v;});} });
    });
    document.getElementById('pzSubClear').addEventListener('click',function(){ state[key]=[]; body.querySelectorAll('input[type=checkbox]').forEach(function(cb){cb.checked=false;}); });
  }

  function renderMainHeader(){
    document.getElementById('pzFilterHeaderInner').innerHTML='<span class="pzc-filter__title">フィルター<\/span>';
    var ft=document.querySelector('.pzc-filter__footer'); if(ft) ft.style.display='';
  }

  /* ── フィルタリング ── */
  function matchSize(itemSizes, selectedKeys){
    /* itemSizesのタグを統合キーに変換してマッチ */
    return itemSizes.some(function(tag){
      var k = tagToSizeKey[tag];
      return k && selectedKeys.indexOf(k) >= 0;
    });
  }

  function applyFilter(){
    if(currentSub){ currentSub=null; renderMainHeader(); renderMain(); return; }
    var grid=document.getElementById('product-grid');
    if(!grid){closeSheet();return;}
    grid.querySelectorAll('.grid__item').forEach(function(el){el.style.display='';});
    grid.querySelectorAll('.pz-load-more-row').forEach(function(el){el.style.display='none';});
    var cards=grid.querySelectorAll('.grid__item'), visible=0;
    cards.forEach(function(card){
      var link=card.querySelector('a[href^="/products/"]');
      if(!link){card.style.display='';visible++;return;}
      var href=decodeURIComponent(link.getAttribute('href').split('?')[0]);
      var item=items.find(function(it){return it.h===href;});
      if(!item){card.style.display='none';return;}
      var show=true;
      if(state.cat.length&&state.cat.indexOf(item.tp)<0)show=false;
      if(show&&state.sz.length){
        /* サイズはAND条件: 選択したサイズ全てを含む商品のみ表示 */
        var itemSizeKeys=(item.sz||[]).map(function(t){return tagToSizeKey[t];}).filter(Boolean);
        var allMatch=state.sz.every(function(k){return itemSizeKeys.indexOf(k)>=0;});
        if(!allMatch)show=false;
      }
      if(show&&state.pr.length&&!(item.pr||[]).some(function(v){return state.pr.indexOf(v)>=0;}))show=false;
      if(show&&state.mt.length&&!(item.mt||[]).some(function(v){return state.mt.indexOf(v)>=0;}))show=false;
      if(show&&state.mk.length&&state.mk.indexOf(item.v)<0)show=false;
      if(show&&(item.pn<state.pMin||item.pn>state.pMax))show=false;
      card.style.display=show?'':'none';
      if(show)visible++;
    });
    var cnt=document.getElementById('pzFilterCount'); if(cnt)cnt.textContent=visible+'件';
    var total=state.cat.length+state.sz.length+state.pr.length+state.mt.length+state.mk.length;
    if(state.pMin>minP||state.pMax<maxP)total++;
    var badge=document.getElementById('pzFilterBadge'); if(badge)badge.textContent=total>0?'('+total+')':'';
    pushURL(state);
    if(state.sort&&state.sort!=='default'){
      applySort(state.sort);
    } else if(window.pzRankData && Object.keys(window.pzRankData).length > 0){
      applySort('default');
    }
    closeSheet();
  }

  function resetFilter(){
    state={cat:[],sz:[],pr:[],mt:[],mk:[],pMin:minP,pMax:maxP,sort:'default'};
    currentSub=null;renderMainHeader();renderMain();
    var grid=document.getElementById('product-grid');
    if(grid){
      grid.querySelectorAll('.grid__item').forEach(function(c){ var g=c.getAttribute('data-pz-group'); c.style.display=(g&&parseInt(g)>0)?'none':''; });
      grid.querySelectorAll('.pz-load-more-row').forEach(function(el){ el.style.display=el.getAttribute('data-next-group')==='1'?'':'none'; });
    }
    var cnt=document.getElementById('pzFilterCount');if(cnt)cnt.textContent=TOTAL+'件';
    var badge=document.getElementById('pzFilterBadge');if(badge)badge.textContent='';
    var sel=document.getElementById('pzSortSelect');if(sel)sel.value='default';
    history.replaceState(null,'',window.location.pathname+(KW?'?kw='+encodeURIComponent(KW):''));
  }

/* PC クイックドロップダウン構築 */
  function buildQuickDropdown(key, containerId){
    var container=document.getElementById(containerId);
    if(!container) return;
    var f=filters[key];
    var keys;
    if(key==='sz'){
      keys=sizeDisplayOrder.filter(function(k){return filters.sz.map[k];});
    } else {
      keys=sortedKeys(f.map);
    }
    var html='';
    keys.forEach(function(v){
      var checked=state[key].indexOf(v)>=0;
      var label=(key==='sz'&&sizeDisplayLabels[v])?sizeDisplayLabels[v]:v;
      html+='<label class="pzc-quick-item"><input type="checkbox" data-key="'+key+'" value="'+esc(v)+'"'+(checked?' checked':'')+'>'+esc(label)+' <span class="pzc-quick-count">'+f.map[v]+'<\/span><\/label>';
    });
    html+='<div class="pzc-quick-actions"><a href="javascript:void(0)" class="pzc-quick-clear" data-key="'+key+'">クリア<\/a><button type="button" class="pzc-quick-apply">適用<\/button><\/div>';
    container.innerHTML=html;
    container.querySelectorAll('input[type=checkbox]').forEach(function(cb){
      cb.addEventListener('change',function(e){e.stopPropagation();var k=this.getAttribute('data-key'),v=this.value;if(this.checked){if(state[k].indexOf(v)<0)state[k].push(v);}else{state[k]=state[k].filter(function(x){return x!==v;});}applyFilter();refreshQuickDropdowns();});
    });
    var clr=container.querySelector('.pzc-quick-clear');
    if(clr) clr.addEventListener('click',function(e){e.stopPropagation();var k=this.getAttribute('data-key');state[k]=[];container.querySelectorAll('input[type=checkbox]').forEach(function(cb){cb.checked=false;});applyFilter();refreshQuickDropdowns();});
    var applyBtn=container.querySelector('.pzc-quick-apply');
    if(applyBtn) applyBtn.addEventListener('click',function(e){e.stopPropagation();container.parentElement.classList.remove('pzc-quick--open');applyFilter();});
    container.addEventListener('click',function(e){e.stopPropagation();});
  }

  function refreshQuickDropdowns(){
    ['sz','mk'].forEach(function(key){
      var cid=key==='sz'?'pzQuickSizeDrop':'pzQuickMakerDrop';
      var container=document.getElementById(cid);
      if(!container) return;
      container.querySelectorAll('input[type=checkbox]').forEach(function(cb){
        cb.checked=state[key].indexOf(cb.value)>=0;
      });
    });
  }

  function openSheet(){
    document.getElementById('pzFilterOverlay').classList.add('pzc-filter-overlay--on');
    document.getElementById('pzFilterSheet').classList.add('pzc-filter-sheet--on');
    document.body.style.overflow='hidden'; currentSub=null; renderMainHeader(); renderMain();
  }
  function closeSheet(){
    document.getElementById('pzFilterOverlay').classList.remove('pzc-filter-overlay--on');
    document.getElementById('pzFilterSheet').classList.remove('pzc-filter-sheet--on');
    document.body.style.overflow='';
  }

  function applySort(val){
    var grid=document.getElementById('product-grid');if(!grid)return;
    /* ソート時は全カード展開 */
    grid.querySelectorAll('.grid__item').forEach(function(el){el.style.display='';});
    grid.querySelectorAll('.pz-load-more-row').forEach(function(el){el.style.display='none';});
    /* おすすめ=販売実績順(pzRankData) / データなければDOM元順 */
    if(val==='default'){
      var hasRank = window.pzRankData && Object.keys(window.pzRankData).length > 0;
      if(hasRank){
        var allCards=Array.from(grid.querySelectorAll('.grid__item'));
        allCards.sort(function(a,b){
          var la=a.querySelector('a[href^="/products/"]'),lb=b.querySelector('a[href^="/products/"]');
          if(!la||!lb)return 0;
          var ha=decodeURIComponent(la.getAttribute('href').split('?')[0]),hb=decodeURIComponent(lb.getAttribute('href').split('?')[0]);
          var ia=items.find(function(x){return x.h===ha;}),ib=items.find(function(x){return x.h===hb;});
          var ra=ia?(ia.rank||0):0, rb=ib?(ib.rank||0):0;
          if(rb!==ra)return rb-ra; /* 販売数降順 */
          return (ib.pa||'').localeCompare(ia.pa||''); /* 同率は公開日降順 */
        });
        allCards.forEach(function(c){grid.appendChild(c);});
      } else {
        originalOrder.forEach(function(c){grid.appendChild(c);});
      }
      if(hasActive(state)){
        Array.from(grid.querySelectorAll('.grid__item')).forEach(function(card){
          var link=card.querySelector('a[href^="/products/"]');
          if(!link)return;
          var href=decodeURIComponent(link.getAttribute('href').split('?')[0]);
          var item=items.find(function(it){return it.h===href;});
          if(!item){card.style.display='none';return;}
          var show=true;
          if(state.cat.length&&state.cat.indexOf(item.tp)<0)show=false;
          if(show&&state.sz.length){var isk=(item.sz||[]).map(function(t){return tagToSizeKey[t];}).filter(Boolean);if(!state.sz.every(function(k){return isk.indexOf(k)>=0;}))show=false;}
          if(show&&state.pr.length&&!(item.pr||[]).some(function(v){return state.pr.indexOf(v)>=0;}))show=false;
          if(show&&state.mt.length&&!(item.mt||[]).some(function(v){return state.mt.indexOf(v)>=0;}))show=false;
          if(show&&state.mk.length&&state.mk.indexOf(item.v)<0)show=false;
          if(show&&(item.pn<state.pMin||item.pn>state.pMax))show=false;
          card.style.display=show?'':'none';
        });
      }
      return;
    }
    var cards=Array.from(grid.querySelectorAll('.grid__item'));
    cards.sort(function(a,b){
      var la=a.querySelector('a[href^="/products/"]'),lb=b.querySelector('a[href^="/products/"]');
      if(!la||!lb)return 0;
      var ha=decodeURIComponent(la.getAttribute('href').split('?')[0]),hb=decodeURIComponent(lb.getAttribute('href').split('?')[0]);
      var ia=items.find(function(x){return x.h===ha;}),ib=items.find(function(x){return x.h===hb;});
      if(!ia||!ib)return 0;
      if(val==='price-asc')return ia.pn-ib.pn; if(val==='price-desc')return ib.pn-ia.pn;
      if(val==='oz-asc'){if(!ia.oz&&!ib.oz)return 0;if(!ia.oz)return 1;if(!ib.oz)return -1;return ia.oz-ib.oz;}
      if(val==='oz-desc'){if(!ia.oz&&!ib.oz)return 0;if(!ia.oz)return 1;if(!ib.oz)return -1;return ib.oz-ia.oz;}
      if(val==='updated'){return (ib.pa||'').localeCompare(ia.pa||'');}
      if(val==='vendor')return (ia.v||'').localeCompare(ib.v||'');
      return 0;
    });
    cards.forEach(function(c){grid.appendChild(c);});
    /* ソート後にフィルターが有効なら再適用 */
    if(hasActive(state)){
      cards.forEach(function(card){
        var link=card.querySelector('a[href^="/products/"]');
        if(!link){return;}
        var href=decodeURIComponent(link.getAttribute('href').split('?')[0]);
        var item=items.find(function(it){return it.h===href;});
        if(!item){card.style.display='none';return;}
        var show=true;
        if(state.cat.length&&state.cat.indexOf(item.tp)<0)show=false;
        if(show&&state.sz.length){
          var itemSizeKeys=(item.sz||[]).map(function(t){return tagToSizeKey[t];}).filter(Boolean);
          var allMatch=state.sz.every(function(k){return itemSizeKeys.indexOf(k)>=0;});
          if(!allMatch)show=false;
        }
        if(show&&state.pr.length&&!(item.pr||[]).some(function(v){return state.pr.indexOf(v)>=0;}))show=false;
        if(show&&state.mt.length&&!(item.mt||[]).some(function(v){return state.mt.indexOf(v)>=0;}))show=false;
        if(show&&state.mk.length&&state.mk.indexOf(item.v)<0)show=false;
        if(show&&(item.pn<state.pMin||item.pn>state.pMax))show=false;
        card.style.display=show?'':'none';
      });
    }
  }

  function injectCSS(){
    var s=document.createElement('style');
    s.textContent='.pzc-filter-row{display:flex;align-items:center;justify-content:space-between;padding:14px 0;border-bottom:1px solid #f0f0f0;cursor:pointer;transition:background 0.15s}'
      +'.pzc-filter-row:active{background:#f9f9f9}'
      +'.pzc-filter-row__label{font-size:14px;font-weight:600;color:var(--pzc-black,#111)}'
      +'.pzc-active-chip{display:inline-flex;align-items:center;padding:6px 10px;background:var(--pzc-light,#f5f5f5);border:1px solid var(--pzc-border,#e5e5e5);border-radius:20px;font-size:12px;font-weight:500;color:var(--pzc-black,#111);cursor:pointer;transition:all 0.15s}'
      +'.pzc-active-chip:hover{border-color:var(--pzc-red,#FF3C00);color:var(--pzc-red,#FF3C00)}'
      /* dual range slider thumb */
      +'#pzPriceMin::-webkit-slider-thumb,#pzPriceMax::-webkit-slider-thumb{-webkit-appearance:none;width:22px;height:22px;background:var(--pzc-red,#FF3C00);border-radius:50%;cursor:pointer;pointer-events:auto;border:2px solid #fff;box-shadow:0 1px 4px rgba(0,0,0,0.2)}'
      +'#pzPriceMin::-moz-range-thumb,#pzPriceMax::-moz-range-thumb{width:22px;height:22px;background:var(--pzc-red,#FF3C00);border-radius:50%;cursor:pointer;pointer-events:auto;border:2px solid #fff;box-shadow:0 1px 4px rgba(0,0,0,0.2)}';
    /* ボトムシートのスタイル強化 */
      +'.pzc-filter-sheet{background:#fff!important;border-top:2px solid var(--pzc-red,#FF3C00)!important;box-shadow:0 -8px 30px rgba(0,0,0,0.15)!important;border-radius:16px 16px 0 0!important}'
      +'.pzc-filter__header{background:var(--pzc-light,#f5f5f5)!important;border-bottom:1px solid var(--pzc-border,#e5e5e5)!important;border-radius:16px 16px 0 0!important}'
      +'.pzc-filter__footer{background:var(--pzc-light,#f5f5f5)!important;border-top:1px solid var(--pzc-border,#e5e5e5)!important}';
    document.head.appendChild(s);
  }

  function init(){
    injectCSS();
    _buildItems();
    _buildFilters();
    /* 初期DOM順序を保存（おすすめ=手動順に戻す用） */
    var grid0 = document.getElementById('product-grid');
    originalOrder = grid0 ? Array.from(grid0.querySelectorAll('.grid__item')) : [];
    state = stateFromURL();
    var target=document.getElementById('ProductGridContainer')||document.getElementById('main-collection-filters');
    if(!target)return;
var isPC = window.innerWidth >= 750;
    var bar=document.createElement('div');bar.className='pzc-filter-bar';
    var barHTML='<button class="pzc-filter-open-btn" id="pzFilterOpen"><svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M4 6h16M4 12h10M4 18h6"/><\/svg> フィルター <span id="pzFilterBadge"><\/span><\/button>';
    if(isPC && !hideSize){
      barHTML+='<div class="pzc-quick-filter" id="pzQuickSize"><button class="pzc-quick-btn" type="button">サイズ <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><path d="M7 10l5 5 5-5z"/><\/svg><\/button><div class="pzc-quick-dropdown" id="pzQuickSizeDrop"><\/div><\/div>';
    }
    if(isPC){
      barHTML+='<div class="pzc-quick-filter" id="pzQuickMaker"><button class="pzc-quick-btn" type="button">メーカー <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><path d="M7 10l5 5 5-5z"/><\/svg><\/button><div class="pzc-quick-dropdown" id="pzQuickMakerDrop"><\/div><\/div>';
    }
    barHTML+='<span class="pzc-filter-bar__count" id="pzFilterCount">'+TOTAL+'件<\/span>'
      +'<select id="pzSortSelect"><option value="default">おすすめ<\/option><option value="popular" disabled style="color:#ccc">人気順（準備中）<\/option><option value="updated">新着順<\/option><option value="price-asc">安い順<\/option><option value="price-desc">高い順<\/option><option value="oz-asc">軽い順<\/option><option value="oz-desc">厚手順<\/option><option value="vendor">メーカー順<\/option><\/select>';
    bar.innerHTML=barHTML;
target.parentNode.insertBefore(bar,target);
    var overlay=document.createElement('div');overlay.className='pzc-filter-overlay';overlay.id='pzFilterOverlay';overlay.addEventListener('click',closeSheet);document.body.appendChild(overlay);
    var sheet=document.createElement('div');sheet.className='pzc-filter-sheet'+(isPC?' pzc-filter-sheet--pc':'');sheet.id='pzFilterSheet';
    sheet.innerHTML='<div class="pzc-filter__header"><div id="pzFilterHeaderInner"><span class="pzc-filter__title">フィルター<\/span><\/div><button class="pzc-filter__close" id="pzFilterClose">&times;<\/button><\/div><div class="pzc-filter__body" id="pzFilterBody"><\/div><div class="pzc-filter__footer"><button class="pzc-filter__reset" id="pzFilterReset">リセット<\/button><button class="pzc-filter__apply" id="pzFilterApply">適用する<\/button><\/div>';
    document.body.appendChild(sheet);
    document.getElementById('pzFilterOpen').addEventListener('click',openSheet);
    document.getElementById('pzFilterClose').addEventListener('click',closeSheet);
    document.getElementById('pzFilterApply').addEventListener('click',applyFilter);
    document.getElementById('pzFilterReset').addEventListener('click',resetFilter);
    document.getElementById('pzSortSelect').addEventListener('change',function(){ state.sort=this.value; applySort(this.value); pushURL(state); });
/* PC クイックドロップダウン構築+開閉 */
    if(isPC){
      buildQuickDropdown('sz','pzQuickSizeDrop');
      buildQuickDropdown('mk','pzQuickMakerDrop');
      bar.querySelectorAll('.pzc-quick-btn').forEach(function(btn){
        btn.addEventListener('click',function(e){
          e.stopPropagation();
          var p=this.parentElement;
          var wasOpen=p.classList.contains('pzc-quick--open');
          bar.querySelectorAll('.pzc-quick-filter').forEach(function(f){f.classList.remove('pzc-quick--open');});
          if(!wasOpen) p.classList.add('pzc-quick--open');
        });
      });
      document.addEventListener('click',function(){bar.querySelectorAll('.pzc-quick-filter').forEach(function(f){f.classList.remove('pzc-quick--open');});});
    }

    var hasRankSort = window.pzRankData && Object.keys(window.pzRankData).length > 0;
    if(hasActive(state)||state.sort!=='default'||hasRankSort){
      var sel=document.getElementById('pzSortSelect'); if(sel&&state.sort)sel.value=state.sort;
      setTimeout(function(){applyFilter();},100);
    }
    console.log('[pz-collection-filter] v9 init: '+TOTAL+'件');
  }

  window.addEventListener('popstate',function(){ state=stateFromURL(); if(hasActive(state)){applyFilter();}else{resetFilter();} });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  } /* end _pzFilterMain */
})();
